import { Divider } from '@mui/material'
import useImportingJobs from '../useJobs/useImportingJobs'
import JobImportingItem from '../JobItem/JobImportingItem/JobImportingItem'
import JobsTabsItem from './JobsTabsItem'
import { isPendingOrRunning } from 'features/jobs/models/jobs'
import { useAppDispatch } from 'app/state'
import { setJobsPopperState } from 'features/jobs/state/jobsProcessingSlice'

function JobsImportingTab() {
  const dispatch = useAppDispatch()
  const { importingJobs, importingJobsNotCleared, clearJobs, areAnyImportingJobsPending } = useImportingJobs()
  const hasJobs = importingJobsNotCleared.length > 0

  const areAllImportingJobsRunning = importingJobs.every(isPendingOrRunning)

  const handleClose = () => {
    dispatch(setJobsPopperState({ open: false }))
  }
  return (
    <>
      <JobsTabsItem
        hasJobs={hasJobs}
        areJobsRunning={areAnyImportingJobsPending}
        areAllJobsRunning={areAllImportingJobsRunning}
        clearJobs={clearJobs}
      >
        <>
          {importingJobsNotCleared.map((job, i) => (
            <div key={job.jobId}>
              <JobImportingItem job={job} onClose={handleClose} />
              {i !== importingJobsNotCleared.length - 1 && <Divider />}
            </div>
          ))}
        </>
      </JobsTabsItem>
    </>
  )
}

export default JobsImportingTab
